import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  buildingInfo: {
    backgroundColor: palette.shades[200],
    padding: '24px 32px',
    marginTop: '18px',
    borderRadius: '2px'
  },
  pageFooter: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  togglerWrapper: {
    marginTop: '18px',
    display: 'inline-block',
    marginRight: '10px'
  },
  tooglerTooltipTrigger: {
    '& path': {
      fill: palette.info.main
    }
  },
  tooglerTooltip: {
    '& div + div': {
      marginTop: '18px'
    }
  },
  teamsTable: {
    marginTop: '10px',
    backgroundColor: palette.shades[200],
    borderRadius: '2px'
  },
  secondaryButton: {
    backgroundColor: palette.shades[200],
    marginTop: '10px'
  },
  membersSelect: {
    maxWidth: '640px'
  }
}));
export default useStyles;